<div class="login-error">
    {errorMessage}
    {#if GoToItslButton}
        <Button text={$store.i18n.GoToItslButton} id="visitItsl" class="go-to-itsl-button" type="primary" on:click={goToItsl}/>
    {:else if ReloadPage}
        <a href={urlOfSelf}>{$store.i18n.pleaseTryAgain}</a>
    {/if}
</div>

<script>
    import Button from '@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte';
    import { store } from '../store';
    import { requestParams } from '../constants.js';

    export let urlOfSelf = window.location.href;
    export let errorMessage;
    export let GoToItslButton = false;
    export let ReloadPage = false;

    function goToItsl(){
        window.open(`${$store.itslearningLoginUrl}?${requestParams.loginConnectAccount}=true`);
    }
</script>
